import "../../styles/SectionAboutUs.css"
import {getIcon, smoothScrollToId} from "../../utils/helper";

const SectionAboutUs = () => {
    const handleOpenNewTab = () => {
        if(window){
            window.open('https://d-gastro24.de/order/hamirestaurant', '_blank', 'noopener,noreferrer');
        }
    };
    const handleOpenScroll = () => {
        smoothScrollToId('tisch-reservieren')
    }
    return (
        <section className="section about text-center" id={"about-us"} aria-labelledby="about-label"  >
            <div className="container">

                <div className="about-content">
                    <div className="wrap-title">
                        <div className="icon-title">
                            <img src="/assets/images/badge-1.png" width="28" height="41" loading="lazy" alt="badge"
                                 className=" "/>
                        </div>
                        <div className="title">
                            <p className="label-2 section-subtitle slider-reveal">Our Story</p>
                            <div className="icon-separator">
                                {getIcon("separator")}
                            </div>
                        </div>
                    </div>
                    <h2 className="headline-1 section-title">
                        1. Unsere kulinarische Philosophie bei Ha Mi
                    </h2>
                    <div className="section-text">
                        <p>
                            Bei Ha Mi erzählt jeder Geschmack eine Geschichte – eine Geschichte von Kreativität und der
                            Verschmelzung der charakteristischen Merkmale der vietnamesischen Küche mit kulinarischen
                            Einflüssen aus aller Welt.
                        </p>
                        <p>
                            Wir bieten vietnamesische Fusionsgerichte an, bei denen vietnamesische Aromen auf
                            raffinierte Weise mit internationalen Einflüssen kombiniert werden, um neue kulinarische
                            Erlebnisse zu schaffen, die dennoch die Seele der traditionellen Gerichte bewahren.
                        </p>
                    </div>


                    <div className="wrapBtn">
                        {/*<button onClick={handleOpenNewTab}  type="button" className={`btnSecondary btn`}>*/}
                        {/*    <span className={`text text1`}>Online bestellen</span>*/}
                        {/*    <span className={`text text2`} aria-hidden="true">Online bestellen</span>*/}
                        {/*</button>*/}
                        <button onClick={handleOpenScroll} type="button" className={`btnSecondary btn`}>
                            <span className={`text text1`}>Tisch reservieren</span>
                            <span className={`text text2`} aria-hidden="true">Tisch reservieren</span>
                        </button>
                    </div>

                </div>

                <figure className="about-banner">

                    <img src="/assets/images/about-banner.jpg" width="570" height="570" loading="lazy"
                         alt="about banner" className="w-100" data-parallax-item="" data-parallax-speed="1"/>

                    <div className="abs-img abs-img-1 has-before" data-parallax-item="" data-parallax-speed="1.75">
                        <img src="/assets/images/about-abs-image.jpg"  loading="lazy" alt=""
                             className="w-100"/>
                    </div>

                    <div className="abs-img abs-img-2 has-before">
                        <img src="/assets/images/badge-2.png" width="133" height="134" loading="lazy" alt=""/>
                    </div>

                </figure>

                <img src="/assets/images/shape-3.png" width="197" height="194" loading="lazy" alt="" className="shape shape-1"/>

            </div>

        </section>
    )
}
export default SectionAboutUs